export const async_form = function(vue, api) {
    document.getElementById('app').arrive('form.form-async', (form) => {
        form.addEventListener('submit', async (e) => {
            e.preventDefault();
            vue.loading = true;
            var data = {};
            var value;
            var form_data = new FormData(e.srcElement);
            var method = e.srcElement.getAttribute('method');
            method = method ? method : 'GET';
            for (var key of form_data.keys()) {
                value = form_data.getAll(key);
                value = value.length > 1 ? value : (value[0] == '' ? null : value[0]);
                if (value) data[key] = value;
            }
            if (typeof e.submitter !== 'undefined' && typeof e.submitter.name !== 'undefined' && e.submitter.name !== '') data[e.submitter.name] = e.submitter.value;
            var should_push = method == 'GET';
            var action = typeof e.target.action !== 'undefined' && e.target.action !== '' ? e.target.action : window.location.href;
            vue.item = await api.getUrl(action, should_push, data, method);
            vue.loading = false;
        });

        //poniżej przesyłanie danych karty dla tpaya który korzysta z jQuery
        if (document.getElementById("card_payment_form")) {
            document.getElementById("card_continue_btn").addEventListener("click", async (e) => {
                $("#card_payment_form").submit(async (e) => {
                    e.preventDefault();
                    var card_form = document.getElementById("card_payment_form");
                    vue.loading = true;
                    var data = {};
                    var value;
                    var form_data = new FormData(card_form);
                    for (var key of form_data.keys()) {
                        value = form_data.getAll(key);
                        value = value.length > 1 ? value : (value[0] == '' ? null : value[0]);
                        if (value) data[key] = value;
                    }
                    vue.item = await api.getUrl(card_form.action, false, data, 'post');
                    vue.loading = false;
                });
            });
        }
    });
}